import React, { useState, useEffect } from "react";
import moment from "moment";
import { TableSales } from "../components/TableSales";
import { TableOrders } from "../components/TableOrders";
import { TableAvegache } from "../components/TableAvegache";
import { UseAdmin } from "../hooks/UseAdmin";
import { fetchIndicators } from "../Api/fetchIndicators";
import { CalendarIcon } from "../components/shared/CalendarIcon";

export const IndicatorsMonth = () => {
  //const monthEs = moment().subtract(1, "month").format("MMMM");
  const [indicatorDayDateSales, setIndicatorDayDateSales] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const { brandfiBiId, branchFiSucursalId } = UseAdmin();
  const typeIndicator = "monthly";
  const [salesData, setSalesData] = useState(null);
  const [ordersData, setOrdesData] = useState(null);
  const [averageData, setAverageData] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    getDataIndicators();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDataIndicators = async () => {
    setLoading(true);
    setHasError(false); // Reset error state

    if (brandfiBiId != null && branchFiSucursalId != null && typeIndicator != null) {
      const onFailure = (error) => {
        console.log(error);
        setHasError(true);
        setLoading(false);
      };

      const onSuccess = async ({ data }) => {
        console.log(data);

        // Verificar si hay datos válidos
        if (
          !data ||
          !data.body ||
          !data.body.ventas ||
          !data.body.ordenes ||
          !data.body.ticket_promedio
        ) {
          setHasError(true);
          setSalesData(null);
          setOrdesData(null);
          setAverageData(null);
          setIndicatorDayDateSales(null);
        } else {
          setSalesData(data.body.ventas[0]);
          setOrdesData(data.body.ordenes[0]);
          setAverageData(data.body.ticket_promedio[0]);
          const arrdate = data.body.fdiddia.toString();
          const arr = arrdate.split("");
          setIndicatorDayDateSales(arr[4] + arr[5]);
        }

        setLoading(false);
      };

      fetchIndicators(brandfiBiId, branchFiSucursalId, typeIndicator)
        .then(onSuccess)
        .catch(onFailure);
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="container-indicators">
      <div className="container-indicators-grid">
        <div className="conetent-company-date-row">
          <div className="text accent">{branchFiSucursalId}</div>
          <div className="date-container">
            <CalendarIcon className="calendar-icon" />
            <div className="text">Mes {indicatorDayDateSales || moment().format("MM")}</div>
          </div>
        </div>

        <div className="container-table">
          <div className="table-card">
            <TableSales salesData={salesData} isLoading={isLoading} hasError={hasError} />
          </div>
          <div className="table-card">
            <TableOrders ordersData={ordersData} isLoading={isLoading} hasError={hasError} />
          </div>
          <div className="table-card">
            <TableAvegache averageData={averageData} isLoading={isLoading} hasError={hasError} />
          </div>
        </div>
      </div>
    </div>
  );
};
